const AI_TIER_LABELS = {
  low: 'Low',
  medium: 'Medium',
  high: 'High',
  extra_high: 'Extra high',
  extrahigh: 'Extra high',
  xhigh: 'Extra high'
};

const humanizeAiTier = (tier) => {
  const text = String(tier ?? '')
    .trim()
    .toLowerCase();

  if (!text) {
    return 'Medium';
  }

  return AI_TIER_LABELS[text] || AI_TIER_LABELS[text.replace(/_/g, '')] || text;
};

export default humanizeAiTier;
